import { c as _c } from "react/compiler-runtime";
import { AppearanceProvider } from '@onefootprint/appearance';
import { configureFootprint, FootprintProvider } from '@onefootprint/idv';
import { QueryClientProvider } from '@tanstack/react-query';
import type { AppProps } from 'next/app';
import type React from 'react';
import configureI18n from '../../config/initializers/i18next';
import queryClient from '../../config/initializers/react-query';
import { BifrostMachineProvider } from '../bifrost-machine-provider';
const footprint = configureFootprint();
type ProvidersProps = {
  children: React.ReactNode;
  pageProps: AppProps['pageProps'];
};
const Providers = t0 => {
  const $ = _c(8);
  const {
    children,
    pageProps
  } = t0;
  const {
    appearance,
    theme,
    rules,
    language
  } = pageProps;
  configureI18n({
    language: language ?? "en"
  });
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      strategy: ["onboardingSessionToken"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <BifrostMachineProvider><FootprintProvider client={footprint}>{children}</FootprintProvider></BifrostMachineProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== appearance || $[4] !== rules || $[5] !== t2 || $[6] !== theme) {
    t3 = <QueryClientProvider client={queryClient}><AppearanceProvider appearance={appearance} options={t1} rules={rules} theme={theme}>{t2}</AppearanceProvider></QueryClientProvider>;
    $[3] = appearance;
    $[4] = rules;
    $[5] = t2;
    $[6] = theme;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default Providers;